import { useEffect, useRef, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

export const useDeliveryQuote = (address) => {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const last = useRef("");

  useEffect(() => {
    const value = address.trim();
    if (value.length < 8) {
      setQuote(null);
      setError("");
      last.current = "";
      return undefined;
    }
    if (value === last.current) return undefined;
    const timer = setTimeout(async () => {
      setLoading(true);
      setError("");
      try {
        const { data } = await api.post("/delivery/quote", { address: value });
        last.current = value;
        setQuote(data);
      } catch (err) {
        setQuote(null);
        setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      } finally {
        setLoading(false);
      }
    }, 900);
    return () => clearTimeout(timer);
  }, [address]);

  return { quote, loading, error };
};
